import { PageGroup, SubsectionGroup } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import mapping from '@sleepstation/components-markdown-copy-mapping'
import { MarkdownRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { marginTop, mq } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import FooterNav from '../../../shared/FooterNav'
import BreakoutModuleNarrow from '../../../shared/breakoutModules/BreakoutModuleNarrow'
import CardLinkList from './CardLinkList'
import ContactMe from './ContactMe'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.X_LARGE })`
  button {
    ${mq(`smallUp`)} {
      max-width: 324px;
    }
  }
`

const TestimonialLinks = styled(VLayout).attrs({ spacing: 0.5 })`
  ${marginTop(1.5)}
`

const Footer = styled.footer``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackEndOfTherapyThankYouPage = ({ content, enrolmentId }) => (
  <BreakoutModuleNarrow
    hasGradient={false}
    hasBottomBorder={false}
    paddingV={[1, 2, [2.25, 3]]}
  >
    <Layout>
      <PageGroup title={content.title} isClose>
        <MarkdownRenderer htmlAst={content.bodyAst} mapping={mapping} />
        <ContactMe
          content={content.contactMe}
          enrolmentId={enrolmentId}
          statement={content.body}
        />
        <TestimonialLinks>
          <SubsectionGroup title={content.testimonialOptions.title} spacing={1}>
            <CardLinkList links={content.testimonialOptions.links} />
          </SubsectionGroup>
        </TestimonialLinks>
      </PageGroup>
      <Footer>
        <FooterNav nav={content.footerNav} />
      </Footer>
    </Layout>
  </BreakoutModuleNarrow>
)

FeedbackEndOfTherapyThankYouPage.propTypes = {
  content: PropTypes.object.isRequired,
  enrolmentId: PropTypes.string.isRequired,
}

export default FeedbackEndOfTherapyThankYouPage
